var map = {
	"./card_bg_1.webp": 66501,
	"./card_bg_2.webp": 11224,
	"./card_bg_3.webp": 96571,
	"./card_bg_4.webp": 65526,
	"./card_bg_5.webp": 84401,
	"./card_bg_6.webp": 6292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98836;